<div class="ttm-page-title-row" style="background: #293649;">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="title-box text-center">
                    <div class="page-title-heading">
                        <h1 class="title" style="color:white"> Management</h1>
                    </div><!-- /.page-title-captions -->
                </div>
            </div><!-- /.col-md-12 -->
        </div><!-- /.row -->
    </div><!-- /.container -->
</div>

<section class="ttm-row grid-section clearfix mt-115">
    <div class="entry-content">

        <div class="site-main">
            <section class=" clearfix">
                <div class="container">
                    <!-- row -->
                    <div class="mt_10 mb_10 row slick_slider"
                        style="display: flex; justify-content: center; flex-flow: row wrap;">
                        <div class="col-lg-3">
                            <!-- featured-imagebox-team -->
                            <div class="featured-imagebox featured-imagebox-team style4 p-30">
                                <div class="ttm-box-view-overlay">
                                    <div class="featured-thumbnail">
                                        <!-- featured-thumbnail -->
                                        <img class="img-fluid" src="assets/images/CEO-Pic-transformed.png" alt="image">
                                    </div>
                                </div>
                                <div class="featured-content" style="padding: 30px 5px 5px">
                                    <div class="featured-title">
                                        <!-- featured-title -->
                                        <h5><a href="#">Sandip Mohapatra</a></h5>
                                    </div>
                                    <p class="category">
                                        CEO
                                    </p><!-- category -->
                                    <div class="mb_10"></div>

                                </div>
                                <div class="featured-iconbox ttm-media-link">
                                    <div class="media-block">
                                        <a target="_blank" href="https://www.linkedin.com/in/sandipmohapatrausa/"
                                            class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>

                                    </div>
                                </div>
                            </div><!-- featured-imagebox-team end-->
                        </div>

                        <div class="col-lg-3">
                            <!-- featured-imagebox-team -->
                            <div class="featured-imagebox featured-imagebox-team style4  p-30">
                                <div class="ttm-box-view-overlay">
                                    <div class="featured-thumbnail">
                                        <!-- featured-thumbnail -->
                                        <img class="img-fluid" src="assets/images/SanatPic-transformed.png" alt="image">
                                    </div>
                                </div>
                                <div class="featured-content" style="padding: 30px 5px 5px">
                                    <div class="featured-title">
                                        <!-- featured-title -->
                                        <h5><a href="#">Sanat Mohapatra</a></h5>
                                    </div>
                                    <p class="category designation">Co-CEO</p><!-- category -->

                                </div>
                                <div class="featured-iconbox ttm-media-link">
                                    <div class="media-block">
                                        <a target="_blank" href="https://www.linkedin.com/in/sanat-mohapatra-51973799/"
                                            class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>

                                    </div>
                                </div>
                            </div><!-- featured-imagebox-team end-->
                        </div>

                        <div class="col-lg-3">
                            <!-- featured-imagebox-team -->
                            <div class="featured-imagebox featured-imagebox-team style4  p-30">
                                <div class="ttm-box-view-overlay">
                                    <div class="featured-thumbnail">
                                        <!-- featured-thumbnail -->
                                        <img class="img-fluid" src="assets/images/Jabeen.png" alt="image">
                                    </div>
                                </div>
                                <div class="featured-content" style="padding: 30px 5px 5px">
                                    <div class="featured-title">
                                        <!-- featured-title -->
                                        <h5><a href="#">Jabeen Sultana</a></h5>
                                    </div>
                                    <p class="category">Head of HR</p><!-- category -->

                                </div>
                                <div class="featured-iconbox ttm-media-link">
                                    <div class="media-block">
                                        <a target="_blank" href="https://www.linkedin.com/in/jabeen-sultana-60992a23/"
                                            class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>

                                    </div>
                                </div>
                            </div><!-- featured-imagebox-team end-->
                        </div>



                    </div>

                    <div class="mt_10 mb_10 row slick_slider"
                        style="display: flex; justify-content: center; flex-flow: row wrap;">

                        <!-- <div class="col-lg-3">
                                <div class="featured-imagebox featured-imagebox-team style4  p-30">
                                    <div class="ttm-box-view-overlay">
                                        <div class="featured-thumbnail">
                                            <img class="img-fluid" src="images/RamaNTalluri-transformed.png"
                                                 alt="image">
                                        </div>
                                    </div>
                                    <div class="featured-content" style="padding: 30px 5px 5px">
                                        <div class="featured-title">
                                            <h5><a href="#">Rama Talluri</a></h5>
                                        </div>
                                        <p class="category">VP of Technology &<br/> Senior Solutions Architect</p>

                                    </div>
                                    <div class="featured-iconbox ttm-media-link">
                                        <div class="media-block">
                                            <a target="_blank" href="https://www.linkedin.com/in/ramanareshtalluri/"
                                               class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>

                                        </div>
                                    </div>
                                </div>
                            </div> -->

                        <!-- <div class="col-lg-3">
                                <div class="featured-imagebox featured-imagebox-team style4  p-30">
                                    <div class="ttm-box-view-overlay">
                                        <div class="featured-thumbnail">
                                            <img class="img-fluid" src="images/leviratnakar.JPG" alt="image">
                                        </div>
                                    </div>
                                    <div class="featured-content">
                                        <div class="featured-title">
                                            <h5><a href="#">Levi Ratnakar</a></h5>
                                        </div>
                                        <p class="category">Director of Technology</p>

                                    </div>
                                    <div class="featured-iconbox ttm-media-link">
                                        <div class="media-block">
                                            <a target="_blank"
                                               href="https://www.linkedin.com/in/levi-ratnakar-b817116a/"
                                               class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>

                                        </div>
                                    </div>
                                </div>
                            </div> -->

                        <!-- <div class="col-lg-3">
                                <div class="featured-imagebox featured-imagebox-team style4  p-30">
                                    <div class="ttm-box-view-overlay">
                                        <div class="featured-thumbnail">
                                            <img class="img-fluid" src="images/nidhi_priya-transformed2.png"
                                                 alt="image">
                                        </div>
                                    </div>
                                    <div class="featured-content" style="padding: 30px 5px 5px">
                                        <div class="featured-title">
                                            <h5><a href="#">Nidhi Priya</a></h5>
                                        </div>
                                        <p class="category">Director of Quality Assurance</p>

                                    </div>
                                    <div class="featured-iconbox ttm-media-link">
                                        <div class="media-block">
                                            <a target="_blank" href="https://www.linkedin.com/in/nidhi-priya-20685310/"
                                               class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>

                                        </div>
                                    </div>
                                </div>
                            </div> -->



                    </div>

                    <div class="mt_10 mb_10 row slick_slider "
                        style="display: flex; justify-content: center; flex-flow: row wrap;">
                        <div class="col-lg-3 d-none">
                            <!-- featured-imagebox-team -->
                            <div class="featured-imagebox featured-imagebox-team style4  p-30">
                                <div class="ttm-box-view-overlay">
                                    <div class="featured-thumbnail">
                                        <!-- featured-thumbnail -->
                                        <img class="img-fluid" src="assets/images/koushik1-transformed.png" alt="image">
                                    </div>
                                </div>
                                <div class="featured-content" style="padding: 30px 5px 5px">
                                    <div class="featured-title">
                                        <!-- featured-title -->
                                        <h5><a href="#">Koushik Kannan</a></h5>
                                    </div>
                                    <p class="category">Automation Architect</p><!-- category -->

                                </div>
                                <div class="featured-iconbox ttm-media-link">
                                    <div class="media-block">
                                        <a target="_blank" href="https://www.linkedin.com/in/koushik-kannan-0a962819/"
                                            class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>
                                    </div>
                                </div>
                            </div><!-- featured-imagebox-team end-->
                        </div>



                    </div>


                    <div class="mt_10 mb_10 row slick_slider"
                        style="display: flex; justify-content: center; flex-flow: row wrap;">

                        <div class="col-lg-3">
                            <!-- featured-imagebox-team -->
                            <div class="featured-imagebox featured-imagebox-team style4  p-30">
                                <div class="ttm-box-view-overlay">
                                    <div class="featured-thumbnail">
                                        <!-- featured-thumbnail -->
                                        <img class="img-fluid" src="assets/images/chenchukumaryeturu.png" alt="image">
                                    </div>
                                </div>
                                <div class="featured-content" style="padding: 30px 5px 5px">
                                    <div class="featured-title">
                                        <!-- featured-title -->
                                        <h5><a href="#">Chenchu Kumar</a></h5>
                                    </div>
                                    <p class="category">Manager, Mobile & UI/UX</p><!-- category -->

                                </div>
                                <div class="featured-iconbox ttm-media-link">
                                    <div class="media-block">
                                        <a target="_blank" href="https://www.linkedin.com/in/chenchukumaryeturu"
                                            class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>
                                    </div>
                                </div>
                            </div><!-- featured-imagebox-team end-->
                        </div>

                        <div class="col-lg-3">
                            <!-- featured-imagebox-team -->
                            <div class="featured-imagebox featured-imagebox-team style4  p-30">
                                <div class="ttm-box-view-overlay">
                                    <div class="featured-thumbnail">
                                        <!-- featured-thumbnail -->
                                        <img class="img-fluid" src="assets/images/sangitasuvadarsini.png" alt="image">
                                    </div>
                                </div>
                                <div class="featured-content" style="padding: 30px 5px 5px">
                                    <div class="featured-title">
                                        <!-- featured-title -->
                                        <h5><a href="#">Sangita Suvadarsini</a></h5>
                                    </div>
                                    <p class="category">Project Manager</p><!-- category -->

                                </div>
                                <div class="featured-iconbox ttm-media-link">
                                    <div class="media-block">
                                        <a target="_blank"
                                            href="https://www.linkedin.com/in/sangita-suvadarsini-106838219/"
                                            class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>

                                    </div>
                                </div>
                            </div><!-- featured-imagebox-team end-->
                        </div>



                        <div class="col-lg-3">
                            <!-- featured-imagebox-team -->
                            <div class="featured-imagebox featured-imagebox-team style4  p-30">
                                <div class="ttm-box-view-overlay">
                                    <div class="featured-thumbnail">
                                        <!-- featured-thumbnail -->
                                        <img class="img-fluid" src="assets/images/srinivas.png" alt="image">
                                    </div>
                                </div>
                                <div class="featured-content" style="padding: 30px 5px 5px">
                                    <div class="featured-title">
                                        <!-- featured-title -->
                                        <h5><a href="#">Srinivas Jayaram</a></h5>
                                    </div>
                                    <p class="category">Head of Recruiting</p><!-- category -->

                                </div>
                                <div class="featured-iconbox ttm-media-link">
                                    <div class="media-block">
                                        <a target="_blank" href="https://www.linkedin.com/in/srinivas-jayaram-a994452a/"
                                            class="media-btn" tabindex="0"><i class="fa fa-linkedin"></i></a>
                                    </div>
                                </div>
                            </div><!-- featured-imagebox-team end-->
                        </div>
                    </div>
                </div>

            </section>
        </div>
    </div>
</section>